import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateContours, updateContourChoice } from '../../actions/uitool';

class ContourToolComp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      breaksValid: true,
      numberValid: true,
      breaksValue: props.contourBreaks.toString(),
      numberValue: props.nContours,
      type: 'number'
    }
  }

  handleUpdate(type) {
    var values;
    var breaks = [];
    if(type === 'number') {
      this.props.dispatch(updateContours(this.state.numberValue, []));
    } else {
      values = this.state.breaksValue.split(",");
      values.forEach(function(val){
        breaks.push(parseFloat(val, 10));
      })
      this.props.dispatch(updateContours(this.state.numberValue, breaks));
    }
  }

  handleRadioChange(e) {
    this.setState({type: e.target.value})
    this.props.dispatch(updateContourChoice(e.target.value));
  }

  handleContourNumberChange(e) {
    var value = e.target.value;
    if(parseInt(+value, 10) > 2 && parseInt(+value, 10) < 21 && !isNaN(parseInt(+value, 10))) {
      this.setState({numberValid: true, numberValue: parseInt(+value, 10)})
    } else {
      this.setState({numberValid: false, numberValue: value})
    }
  }

  handleBreaksChange(e) {
    var value = e.target.value;
    var values = value.split(",");
    if(values.length < 21 && values.length > 2 && !values.some(isNaN)) {
      this.setState({breaksValid: true, breaksValue: value})
    } else {
      this.setState({breaksValid: false, breaksValue: value})
    }
  }

  render() {
    
    var breaks = this.state.breaksValue;
    var number = this.state.numberValue;

    return (
      <div style={{paddingTop: '5px', marginTop: '7px', borderTop: '1px solid'}}>

        <h5>IDW Contour Layer</h5>
        <fieldset style={{paddingLeft: '8px'}} className="form-group" onChange={this.handleRadioChange.bind(this)}>
          <div className="form-check">
            <label className="form-check-label">
              <input type="radio" className="form-check-input" name="optionsRadios" id="optionsRadios1" value="number" defaultChecked/>
              Change the number of contours created using the default contouring function.
            </label>
          </div>
          <div className="form-check">
          <label className="form-check-label">
              <input type="radio" className="form-check-input" name="optionsRadios" id="optionsRadios2" value="breaks"/>
              Set contour levels manually. 
            </label>
          </div>
        </fieldset>
 
        { this.state.type === 'number' ? (<div className="form-group">
          <label className="form-control-label">Set the Number of Contours</label>
          <input type="text" value={number} className={this.state.numberValid ? "form-control" : "form-control is-invalid"} onChange={this.handleContourNumberChange.bind(this)}/>
          { !this.state.numberValid ? (<div className="invalid-feedback">Please use an integer from 3 - 20.</div>) : null }
        </div>) : null }
        { this.state.type === 'breaks' ? (<div className="form-group">
          <label className="form-control-label">Set Contour Breaks</label>
          <input type="text" value={breaks} className={this.state.breaksValid ? "form-control" : "form-control is-invalid"} onChange={this.handleBreaksChange.bind(this)}/>
          { !this.state.breaksValid ? (<div className="invalid-feedback">Please use valid numbers in a comma-separated list of length at least 3 and no more than 20.</div>) : null }
        </div>) : null }

        { this.state.type === 'number' ? (<button disabled={!this.state.numberValid} type="submit" className={this.state.numberValid ? "btn btn-primary" : "btn btn-primary disabled"} onClick={this.handleUpdate.bind(this, 'number')}>Update</button>) : null }
        { this.state.type === 'breaks' ? (<button disabled={!this.state.breaksValid} type="submit" className={this.state.breaksValid ? "btn btn-primary" : "btn btn-primary disabled"} onClick={this.handleUpdate.bind(this, 'breaks')}>Update</button>) : null }

      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    nContours: state.uiApp.get('nContours'),
    contourBreaks: state.uiApp.get('contourBreaks'),
    useSetContourBreaks: state.uiApp.get('useSetContourBreaks')
  }
}

const ContourTool = connect(mapStateToProps)(ContourToolComp);

export default ContourTool;


// WEBPACK FOOTER //
// ./src/components/uiTool/ContourTool.js